// Regionale landingspagina-data voor SEO. Feitelijk neutraal geformuleerd:
// Work4you is een marktplaats die vraag en aanbod koppelt in deze regio's.
export const REGIOS = {
  vlaanderen: {
    slug: "vlaanderen",
    naam: "Vlaanderen",
    type: "Region",
    metaTitle: "Ramen en deuren monteren in Vlaanderen | Monteurs & offertes — Work4you",
    metaDescription:
      "Ramen en deuren laten monteren in Vlaanderen? Vind geverifieerde raam- en kozijnenmonteurs, plaats opdrachten en vraag gratis offertes aan voor PVC, aluminium en houten ramen, schuiframen en voordeuren.",
    keywords:
      "ramen monteren Vlaanderen, raammonteurs Vlaanderen, kozijnenmonteurs Vlaanderen, ramen en deuren Vlaanderen, PVC ramen Vlaanderen, aluminium ramen Vlaanderen, houten ramen Vlaanderen, offerte ramen Vlaanderen, nieuwe ramen en deuren Vlaanderen",
    intro: [
      "Op zoek naar een vakman voor de montage van ramen en deuren in Vlaanderen? Work4you koppelt particulieren, bedrijven en zelfstandige monteurs in heel Vlaanderen. Plaats een opdracht, doorzoek de monteursgids of vraag gratis een prijsofferte aan voor PVC, aluminium of houten ramen, schuiframen en voordeuren.",
      "Van een enkele raamvervanging tot een volledige woningrenovatie: je vergelijkt eenvoudig geverifieerde bedrijven en monteurs die actief zijn in jouw provincie — Antwerpen, Oost-Vlaanderen, West-Vlaanderen, Limburg en Vlaams-Brabant.",
    ],
    provincies: ["Antwerpen", "Oost-Vlaanderen", "West-Vlaanderen", "Limburg", "Vlaams-Brabant"],
    steden: ["Antwerpen", "Gent", "Brugge", "Leuven", "Mechelen", "Aalst", "Kortrijk", "Hasselt", "Oostende", "Genk", "Roeselare", "Sint-Niklaas"],
  },
  "vlaams-brabant": {
    slug: "vlaams-brabant",
    naam: "Vlaams-Brabant",
    type: "AdministrativeArea",
    metaTitle: "Ramen en deuren monteren in Vlaams-Brabant | Monteurs & offertes — Work4you",
    metaDescription:
      "Ramen en deuren laten monteren in Vlaams-Brabant? Vind raam- en kozijnenmonteurs rond Leuven, Vilvoorde en Halle, plaats opdrachten en vraag gratis offertes aan voor PVC, aluminium en houten ramen en voordeuren.",
    keywords:
      "ramen monteren Vlaams-Brabant, raammonteurs Vlaams-Brabant, kozijnenmonteurs Leuven, ramen en deuren Vlaams-Brabant, PVC ramen Leuven, aluminium ramen Vilvoorde, offerte ramen Vlaams-Brabant, nieuwe ramen en deuren Vlaams-Brabant",
    intro: [
      "Zoek je een monteur voor ramen en deuren in Vlaams-Brabant? Work4you brengt particulieren, bedrijven en zelfstandige monteurs samen in de hele provincie. Plaats je opdracht, doorzoek de monteursgids of vraag gratis een offerte aan voor PVC, aluminium of houten ramen, schuiframen en voordeuren.",
      "Of je nu in de regio Leuven, het Hageland, de Druivenstreek of de rand rond Brussel woont — je vindt snel een geverifieerde vakman voor een nieuwe raamvervanging of een volledige renovatie van je raamkozijnen.",
    ],
    provincies: ["Vlaams-Brabant"],
    steden: ["Leuven", "Vilvoorde", "Halle", "Tienen", "Aarschot", "Diest", "Zaventem", "Grimbergen", "Asse", "Dilbeek", "Overijse", "Tervuren"],
  },
};

export const REGIO_LIST = Object.values(REGIOS);
